import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFilterJunctionInZoneTable extends Layout {
    sourceMCFilterJunctionInZone: DataSource;
    tableMCFilterJunctionInZone: Table;
}
